module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_12.png?d752d96683757a21612926c16e2028fe";